module.exports = __webpack_public_path__ + "static/img/mobile_home_cpjfw_zfjjfa.cd24de2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile_home_cpjfw_zfjjfa.png
// module id = oQRo
// module chunks = 21